<template>
  <div class="table-responsive">
    <DataTable
      :key="columns.length"
      class="display table table-bordered table-sm text-sm" :data="filteredData" :columns="columns"
      :options="{ paging: false }" />
  </div>
</template>
<script>
import DataTable from 'datatables.net-vue3';
import DataTablesCore from 'datatables.net-bs5';
DataTable.use(DataTablesCore);

const hoursFormatter = new Intl.NumberFormat(navigator.languages, {minimumFractionDigits: 2, maximumFractionDigits: 2})

export default {
  name: 'CoverageTable',
  components: {
    DataTable
  },
  props: {
    users: {
      type: Map,
      required: true
    },
    timelogs: {
      type: Array,
      required: true
    },
    startDate: {
      type: Date,
      required: true
    },
    endDate: {
      type: Date,
      required: true
    },
    userIdsFilter: {
      type: Set,
      required: true
    },
  },
  computed: {
    columns() {
      const dates = []
      for (let date = this.startDate; date <= this.endDate; date.setUTCDate(date.getUTCDate() + 1)) {
        dates.push(new Date(date))
      }
      return [
        {
          title: 'User Name',
          data: 'userId',
          defaultContent: '(Unknown)',
          render: (data) => this.users.get(data)
        },
        {
          title: 'Total',
          data: 'total',
          render: (data) => data ? hoursFormatter.format(data) : '',
          searchable: false
        },
        ...dates.map((date) => ({
          title: Intl.DateTimeFormat(undefined, {weekday: "short", day: "numeric", month: "numeric", timeZone: "UTC"}).format(date),
          data: date.toISOString().replaceAll('.', '\\.'), //plain dots represent nested objects for Datatables.net so we need to escape these
          render: (data) => data ? hoursFormatter.format(data) : '',
          searchable: false,
          sortable: false,
        }))
      ]
    },
    data() {
      const usersCoverage = new Map()
      for (const t of this.timelogs) {
        if (!usersCoverage.has(t.userId)) {
          usersCoverage.set(t.userId, { userId: t.userId })
        }
        const user = usersCoverage.get(t.userId)
        const dateKey = t.trackedDate.toISOString()
        user[dateKey] = (user[dateKey] ?? 0) + t.hours
        user.total = (user.total ?? 0) + t.hours
      }
      return usersCoverage.values().toArray()
    },
    filteredData() {
      return this.data.filter((e) => this.userIdsFilter.has(e.userId))
    }
  }
}
</script>
<style>
@import 'datatables.net-bs5';
</style>